import { ArrowUpRight } from 'lucide-react'

// Filename casing is inconsistent between these two (capital "G" on Drive) and
// Linux builds are case-sensitive — match the files on disk exactly.
import googleDocsIcon from '@/assets/google-docs-icon.png'
import googleDriveIcon from '@/assets/Google-drive-icon.png'
import { Card, CardAction, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Link } from '@/components/ui/Link'

const ASSETS = [
  {
    label: 'Logos',
    description: 'Google Drive folder',
    href: 'https://drive.google.com/drive/folders/1WU6mPX-R1HIbskHAtJbBiSR_w16x-Og7',
    icon: googleDriveIcon,
  },
  {
    label: 'Fonts',
    description: 'Google Drive folder',
    href: 'https://drive.google.com/drive/folders/1IZ6lGQUo96uvw8z8y2XpTGx9V0o_fgrH',
    icon: googleDriveIcon,
  },
  {
    label: 'Letterhead',
    description: 'Google Doc',
    href: 'https://docs.google.com/document/d/1JsgIrV36Tz5oRdcfsp7w8Xad7KZQ9Xjeq4K1NYHmjug/edit',
    icon: googleDocsIcon,
  },
]

/** Source files that live in Google Drive rather than in the codebase. */
export function BrandAssetLinks() {
  return (
    <div className="mt-10">
      <h2 className="text-ink text-2xl font-bold tracking-[-0.01em]">Quick links</h2>
      <div className="mt-4 grid gap-4 sm:grid-cols-3">
        {ASSETS.map((asset) => (
          <Link
            key={asset.href}
            href={asset.href}
            target="_blank"
            rel="noopener noreferrer"
            className="group block"
          >
            {/* Hairline border shift on hover — the system builds depth from
              borders and surface color, never drop shadows. */}
            <Card className="group-hover:border-ink-300 h-full gap-0 transition-colors">
              <CardHeader>
                <CardTitle className="flex items-center gap-2">
                  {/* Neither mark is square, so height is fixed and width follows. */}
                  <img src={asset.icon} alt="" className="h-4 w-auto" />
                  {asset.label}
                </CardTitle>
                <CardDescription>{asset.description}</CardDescription>
                <CardAction>
                  <ArrowUpRight className="text-ink-400 group-hover:text-ink-600 size-4 transition-colors" />
                </CardAction>
              </CardHeader>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  )
}
